import { useCallback } from 'react';
import {
  getSaleDetailsModalConfigWithDeepLink,
  getSaleDetailsRelativeUrl,
} from 'src/utils/saleUtils';
import { ActionOutboxEntityType } from 'src/WebApiController';

import { useEntityActions } from './useEntityActions';

/**
 * Hook for sale-specific actions like opening sale modals.
 */
export const useSaleActions = () => {
  const { loadEntityAndOpenModal } = useEntityActions();

  const openSaleModal = useCallback(
    (
      saleId: number | string,
      dataFields: string[] = [],
      mouseEvent?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
      if (mouseEvent && (mouseEvent.metaKey || mouseEvent.ctrlKey)) {
        mouseEvent.preventDefault();
        const url = getSaleDetailsRelativeUrl(saleId);
        window.open(url, '_blank');
        return;
      }
      const getSaleModalConfig = (id: number | string) => {
        return getSaleDetailsModalConfigWithDeepLink(id);
      };

      loadEntityAndOpenModal(
        ActionOutboxEntityType.Sale,
        saleId,
        null,
        false,
        dataFields,
        false,
        false,
        getSaleModalConfig
      );
    },
    [loadEntityAndOpenModal]
  );

  return {
    openSaleModal,
  };
};
